import {
  take,
  put,
  call,
  all,
  takeLatest,
  takeEvery,
} from 'redux-saga/effects';
import { emailTemplateAction as actions, notificationActions } from '../actions';
import { EmailTemplateService } from '../services';

/* Add Email Type Sagas */
function* handleAddEmailTypeRequest() {
  const action = yield take(actions.addEmailTypeRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(EmailTemplateService.addEmailType, dataParams);
    if (res.isError) {
      yield put(actions.addEmailTypeError(res));
      yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    } else {
      yield put(actions.addEmailTypeSuccess(res));
      yield put(notificationActions.openSnackbar({ text: res?.data?.message || res?.errorMessage, alertType: 'success' }));
    }
  } catch (error) {
    yield put(actions.addEmailTypeError());
    yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
  }
}
/* Get Email Type Sagas */
function* handleGetEmailTypeRequest() {
  const action = yield take(actions.getEmailTypeRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(EmailTemplateService.getEmailType, dataParams);

    if (res.isError) {
      yield put(actions.getEmailTypeError(res));

    } else {
      yield put(actions.getEmailTypeSuccess(res));
    }

  } catch (error) {
    yield put(actions.getDepartmentError());
  }
}
/* Add Email Template Sagas */
function* handleAddEmailTemplateRequest() {
  const action = yield take(actions.addEmailTemplateRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(EmailTemplateService.addEmailTemplate, dataParams);
    if (res.isError) {
      yield put(actions.addEmailTemplateError(res));
      yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    } else {
      yield put(actions.addEmailTemplateSuccess(res));
      yield put(notificationActions.openSnackbar({ text: res?.data?.message || res?.errorMessage, alertType: 'success' }));
    }
  } catch (error) {
    yield put(actions.addEmailTemplateError());
    yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
  }
}

/* Get Email Template Sagas */
function* handleGetEmailTemplateRequest() {
  const action = yield take(actions.getEmailTemplateRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(EmailTemplateService.getEmailTemplate, dataParams);
    if (res.isError) {
      yield put(actions.getEmailTemplateError(res));
    } else {
      yield put(actions.getEmailTemplateSuccess(res));

    }
  } catch (error) {
    yield put(actions.getEmailTemplateError());
  }
}


/* Update Email Template Sagas */
function* handleUpdateDepartmentRequest() {
  const action = yield take(actions.updateEmailTemplateRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(EmailTemplateService.updateEmailTemplate, dataParams);
    if (res.isError) {
      yield put(actions.updateEmailTemplateError(res));
      yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    } else {
      yield put(actions.updateEmailTemplateSuccess(res));
      yield put(notificationActions.openSnackbar({ text: res?.data?.message || res?.errorMessage, alertType: 'success' }));
    }
  } catch (error) {
    yield put(actions.updateEmailTemplateError());
    yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
  }
}
/* Delete Email Template Sagas */
function* handleDeleteTemplateRequest() {
  const action = yield take(actions.deleteEmailTemplateRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(EmailTemplateService.deleteEmailTemplate, dataParams);
    if (res.isError) {
      yield put(actions.deleteEmailTemplateError(res));
      yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    } else {
      yield put(actions.deleteEmailTemplateSuccess(res));
      yield put(notificationActions.openSnackbar({ text: res?.data?.message || res?.errorMessage, alertType: 'success' }));
    }
  } catch (error) {
    yield put(actions.deleteEmailTemplateError());
    yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
  }
}

/* Remove Image Template Sagas */
function* handleRemoveImageRequest() {
  const action = yield take(actions.RemoveImageRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(EmailTemplateService.removeImageTemplate, dataParams);
    if (res.isError) {
      yield put(actions.RemoveImageError(res));
      yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    } else {
      yield put(actions.RemoveImageSuccess(res));
      yield put(notificationActions.openSnackbar({ text: res?.data?.message || res?.errorMessage, alertType: 'success' }));
    }
  } catch (error) {
    yield put(actions.RemoveImageError());
    yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
  }
}

/* Add Action Template Sagas */
function* handleAddActionRequest() {
  const action = yield take(actions.AddActionTemplateRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(EmailTemplateService.AddActionEmailTemplate, dataParams);
    if (res.isError) {
      yield put(actions.AddActionTemplateError(res));
      yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    } else {
      yield put(actions.AddActionTemplateSuccess(res));
      yield put(notificationActions.openSnackbar({ text: res?.data?.message || res?.errorMessage, alertType: 'success' }));
    }
  } catch (error) {
    yield put(actions.AddActionTemplateError());
    yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
  }
}

/* Get Action Sagas */
function* handleGetActionRequest() {
  const action = yield take(actions.getActionTemplateRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(EmailTemplateService.getActionEmailTemplate, dataParams);
    if (res.isError) {
      yield put(actions.getActionTemplateError(res));
    } else {
      yield put(actions.getActionTemplateSuccess(res));
    }
  } catch (error) {
    yield put(actions.getActionTemplateError());
  }
}

/* Update Action Sagas */
function* handleUpdateActionRequest() {
  const action = yield take(actions.UpdataActionTemplateRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(EmailTemplateService.UpdateActionEmailTemplate, dataParams);
    if (res.isError) {
      yield put(actions.UpdataActionTemplateError(res));
      yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    } else {
      yield put(actions.UpdataActionTemplateSuccess(res));
      yield put(notificationActions.openSnackbar({ text: res?.data?.message || res?.errorMessage, alertType: 'success' }));
    }
  } catch (error) {
    yield put(actions.UpdataActionTemplateError());
    yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
  }
}
/* Delete Action Sagas */
function* handleDeleteActionRequest() {
  const action = yield take(actions.DeleteActionTemplateRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(EmailTemplateService.DeletActionEmailTemplate, dataParams);
    if (res.isError) {
      yield put(actions.DeleteActionTemplateError(res));
      yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    } else {
      yield put(actions.DeleteActionTemplateSuccess(res));
      yield put(notificationActions.openSnackbar({ text: res?.data?.message || res?.errorMessage, alertType: 'success' }));
    }
  } catch (error) {
    yield put(actions.DeleteActionTemplateError());
    yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
  }
}
/* Get Action Type Sagas */
function* handleGetActionTypeRequest() {
  const action = yield take(actions.GetActionTypeTemplateRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(EmailTemplateService.getActionType, dataParams);
    if (res.isError) {
      yield put(actions.GetActionTypeemplateError(res));
    } else {
      yield put(actions.GetActionTypeemplateSuccess(res));
    }
  } catch (error) {
    yield put(actions.GetActionTypeemplateError());
  }
}




/* -----------Watchers------------- */
function* handleAddemailTypeWatcher() {
  yield takeEvery(
    actions.addEmailTypeRequest,
    handleAddEmailTypeRequest,
  );
}

function* handleGetEmailTypeWatcher() {
  yield takeEvery(
    actions.getEmailTypeRequest,
    handleGetEmailTypeRequest,
  );
}

function* handleaddEmailTemplateWatcher() {
  yield takeEvery(
    actions.addEmailTemplateRequest,
    handleAddEmailTemplateRequest,
  );
}

function* handleGetEmailTemplateWatcher() {
  yield takeEvery(
    actions.getEmailTemplateRequest,
    handleGetEmailTemplateRequest,
  );
}

function* handleUpdateEmailTemplateWatcher() {
  yield takeEvery(
    actions.updateEmailTemplateRequest,
    handleUpdateDepartmentRequest,
  );
}

function* handleDeleteEmailTemplateWatcher() {
  yield takeEvery(
    actions.deleteEmailTemplateRequest,
    handleDeleteTemplateRequest,
  );
}

function* handleremoveImageWatcher() {
  yield takeEvery(
    actions.RemoveImageRequest,
    handleRemoveImageRequest,
  );
}

function* handleAddActionWatcher() {
  yield takeEvery(
    actions.AddActionTemplateRequest,
    handleAddActionRequest,
  );
}

function* handleGetActionWatcher() {
  yield takeEvery(
    actions.getActionTemplateRequest,
    handleGetActionRequest,
  );
}

function* handleUpdateActionWatcher() {
  yield takeEvery(
    actions.UpdataActionTemplateRequest,
    handleUpdateActionRequest,
  );
}

function* handleDeleteActionWatcher() {
  yield takeEvery(
    actions.DeleteActionTemplateRequest,
    handleDeleteActionRequest,
  );
}

function* handleGetActionTypeWatcher() {
  yield takeEvery(
    actions.GetActionTypeTemplateRequest,
    handleGetActionTypeRequest,
  );
}



function* rootEmailTemplate() {
  yield all([
    handleAddEmailTypeRequest(),
    handleAddemailTypeWatcher(),

    handleGetEmailTypeRequest(),
    handleGetEmailTypeWatcher(),

    handleAddEmailTemplateRequest(),
    handleaddEmailTemplateWatcher(),

    handleGetEmailTemplateRequest(),
    handleGetEmailTemplateWatcher(),

    handleUpdateDepartmentRequest(),
    handleUpdateEmailTemplateWatcher(),

    handleDeleteTemplateRequest(),
    handleDeleteEmailTemplateWatcher(),

    handleremoveImageWatcher(),
    handleRemoveImageRequest(),

    handleAddActionWatcher(),
    handleAddActionRequest(),

    handleGetActionRequest(),
    handleGetActionWatcher(),

    handleUpdateActionRequest(),
    handleUpdateActionWatcher(),

    handleDeleteActionRequest(),
    handleDeleteActionWatcher(),

    handleGetActionTypeRequest(),
    handleGetActionTypeWatcher(),
  ]);
}

export default rootEmailTemplate;
